import React, {Component} from 'react';
import {connect} from 'react-redux';
import PerkAction from '../../actions/PerkAction';
import {Form, Control, Errors, actions} from 'react-redux-form';
import Preloader from '../Preloader';
import screen from '../../image/screen.png';
import screenTwo from '../../image/screen_two.png';
import moment from 'moment';

class EditorPerks extends Component {

  componentDidMount() {
    this.props.resetForm();
    if (this.props.params.id) {
      this.props.getPerk(this.props.params.id);
    } else {
      this.props.getBonusPerks();
    }
  }

  componentWillUnmount() {
    this.props.resetForm();
  }

  submit(data) {
    let newData = Object.assign({}, data);
    newData.referral_bonus = this.props.location.query.mode === 'friends_rewards';
    this.props.submitEditor(newData);
  }

  getSelectedPerk (id) {
    if (this.props.bonusPerks != null) {
      for (var index in this.props.bonusPerks) {
        var perk = this.props.bonusPerks[index];
        if (perk.id == id) {
          return perk.title;
        }
      }
    }
  }

  validateExpireDate(date) {
    return date >= moment().format('YYYY-MM-DD') || date === '';
  }

  render() {
    let friendsRewardsMode = this.props.location.query.mode === 'friends_rewards';

    let backUrl = friendsRewardsMode ? '?back=friends_rewards' : '';
    let titlePostfix = friendsRewardsMode ? 'for Friends’ rewards' : 'for Customer Rewards';
    var title = 'Create a Perk ' + titlePostfix;
    let imageScreen = friendsRewardsMode ? screenTwo : screen;

    if (this.props.params.id) {
      title = 'Edit Perk ' + titlePostfix;
    }
    if (this.props.isBusy) {
      return <Preloader/>;
    } else {
      return <div>
        <div className="col-md-6" style={{background:"#13171e"}}>
          <div style={{width: '303px', height: '600px', margin: 'auto',marginBottom: '40px', marginTop: '40px', diplay: 'block', backgroundImage: 'url(' + imageScreen + ')' }}>
            <div style={{width: '100%', height: '103px'}}> </div>
            <div style={{width: '275px', height: '73px', margin: 'auto', diplay: 'block', backgroundImage: 'url(' + this.props.perk.merchant.background_url + ')' }}>
              <div style={{width: '100%', height:'100%', backgroundColor:'#13171e', opacity: '.6'}}>
                <div style={{width: '100%', height: '16px'}}> </div>
                <div style={{width: '100%', height: '30px', textAlign: 'center', fontSize: '25px'}}>
                  <flabel style={{width: '100%', height: '100%', color:"#ffffff"}}>
                    {this.props.perk.merchant.name}
                  </flabel>
                </div>
                <div style={{width: '100%', height: '22px', textAlign: 'center', fontSize: '14px' }}>
                  <label style={{width: '100%', height: '100%', color:"#ffffff"}}>
                    {this.props.perk.merchant.address != null ? this.props.perk.merchant.address.line1 : ''}
                  </label>
                </div>
              </div>
            </div>
            <div className="phone-box">
              <div style={{width: '100%', height: '37px'}}> </div>
              {!friendsRewardsMode ?
                <div style={{width: '100%', height: '30px', textAlign: 'center', fontSize: '25px'}}>
                <label style={{width: '100%', height: '100%', color:"#ffffff"}}>
                  {this.props.perk.required_referrals}
                </label>
              </div> : null}
              <div style={{width: '100%', height: '16px'}}> </div>
              <div style={{width: '100%', height: '36px', textAlign: 'center', fontSize: '25px'}}>
                <label style={{width: '100%', height: '100%', color:"#13171e"}}>
                  {this.props.perk.title}
                </label>
              </div>
              <div style={{width: '100%', height: '88px', textAlign: 'center', fontSize: '14px' }}>
                <label style={{width: '100%', height: '100%', color:"#9d9d9d", lineHeight: '20px'}}>
                  {this.props.perk.description}
                </label>
              </div>
              {friendsRewardsMode ? <div style={{width: '100%', height: '21px'}}> </div> : null}
              <div className="form-group" style={{width: '100%', height: '22px', textAlign: 'center', fontSize: '14px', marginBottom: '5px'}}>
                <label style={{width: '100%', height: '100%', textAlign: 'center', color:"#9d9d9d"}}>Expires {this.props.perk.expire_date}</label>
              </div>
              <div style={{width: '100%', height: '4px'}}> </div>
              <div className="form-group" style={{width: '100%', height: '22px', textAlign: 'center', fontSize: '16px'}}>
                { !friendsRewardsMode ?
                  <label style={{width: '100%', height: '100%', textAlign: 'center', color:"#ffffff"}}>Select Your {this.props.perk.required_referrals} Friends</label> :
                  <label style={{width: '100%', height: '100%', textAlign: 'center', color:"#ffffff"}}>Redeem Now</label>
                }
              </div>
              <div style={{width: '100%', height: '57px'}}> </div>
              <div className="form-group" style={{width: '100%', height: '22px', textAlign: 'center', fontSize: '16px'}}>
                {this.props.bonus_perks !== null &&
                <label style={{width: '100%', height: '100%', textAlign: 'center', color:"#000"}}>{this.getSelectedPerk(this.props.perk.receiver_perk_id)}</label>}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="panel-heading">
            <div style={{width: '100%', height: '33px', marginTop: '30px',textAlign: 'center', fontSize: '25px'}}>
              <label style={{width: '100%', height: '100%', color:"#13171e"}}>
                {title}
              </label>
            </div>
            <div style={{width: '100%', height: '33px', textAlign: 'center', fontSize: '16px'}}>
              <label style={{width: '100%', height: '100%', color:"#9d9d9d"}}>
                Use the guide to the left as a reference when creating your perk promos.
              </label>
            </div>
          </div>
          <div className="panel-body">
            <Form model="forms.perkForm" onSubmit={(data) => this.submit(data)}>
              <div className="form-group">
                <label htmlFor="title">Title</label>
                <Control.text className="form-control" model="forms.perkForm.title" id="title"/>
              </div>
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <Control.textarea className="form-control" model="forms.perkForm.description" id="description"/>
              </div>
              {!friendsRewardsMode ?
              <div className="form-group">
                <label htmlFor="referral_bonus">Referral bonus</label>
                <Control.select model="forms.perkForm.receiver_perk_id" id="receiver_perk_id" className="form-control">
                  <option value="">Select a bonus</option>
                  {this.props.bonusPerks.map(option => <option value={option.id} key={option.id}>{option.title}</option>)}
                </Control.select>
              </div>
                : null}
              {!friendsRewardsMode ?
              <div className="form-group">
                <label htmlFor="enabled">Enabled</label>
                <Control.checkbox model="forms.perkForm.enabled" id="enabled" style={{margin: '0px 15px'}}/>

                  <div>
                    <label htmlFor="requires_qr_code">Requires QR code</label>
                    <Control.checkbox model="forms.perkForm.requires_qr_code" id="requires_qr_code" style={{margin: '0px 15px'}}/>
                  </div>
              </div>: null
              }
              <div className="form-group">
                <label htmlFor="fine_print">Fine print</label>
                <Control.textarea className="form-control" model="forms.perkForm.fine_print" id="fine_print"/>
              </div>
              {!friendsRewardsMode ?
              <div className="form-group">
                <label htmlFor="required_referrals">Required Referrals</label>
                <Control.text className="form-control" type="number" model="forms.perkForm.required_referrals"
                              id="required_referrals"/>
              </div>
                : null}
              <div className="form-group">
                <label htmlFor="expire_date">Expire date</label>
                <Control.text className="form-control" type="date" model="forms.perkForm.expire_date"
                              id="expire_date"
                              validators={{
                                expireDate: this.validateExpireDate.bind(this)
                              }}/>
                <div className="error-box">
                  <Errors
                    className="error"
                    model="forms.perkForm.expire_date"
                    show={(field) => field.submitFailed && !field.valid}
                    messages={{
                      expireDate: 'make sure expiration date is in the future'
                    }}
                  />
                </div>
              </div>
              <button type="submit" className="btn btn-action">Save</button>
              <a href={`/#/perks${backUrl}`} className="btn btn-default ml10">Cancel</a>
            </Form>
          </div>
        </div>
      </div>
    }
  }
}

export default connect(
  state => ({
    isBusy: state.requestStatus,
    perk: state.forms.perkForm,
    bonusPerks: state.forms.perkForm.bonus_perks,
    isBonusPerk: state.forms.perkForm.referral_bonus
  }),
  dispatch => ({
    getPerk: (id) => {
      dispatch(PerkAction.get(id));
    },
    getBonusPerks: () => {
      dispatch(PerkAction.getBonusPerks());
    },
    resetForm: () => {
      dispatch(actions.setValidity('forms.perkForm', true));
      dispatch({type: 'RESET_PERK_FORM'});
    },
    submitEditor: (data) => {
      if (data.id) {
        dispatch(PerkAction.edit(data));
      } else {
        dispatch(PerkAction.add(data));
      }
    }
  })
)(EditorPerks);



/** WEBPACK FOOTER **
 ** ./src/components/Perks/editor.js
 **/